import getFontClass from '../../utils/getFontClass';

const extractHeading = (headings) => {
  let text = '';
  headings.forEach((heading) => {
    text += `<span class="${getFontClass(heading.heading_size)}">${heading.heading_text}</span>`;
  });
  return text;
};

export default (settings, module_name) => {
  const contentContainer = document.querySelector('[data-content-container]');
  const products = contentContainer.innerHTML;
  const headingContainer = document.createElement('div');
  headingContainer.classList.add(`Module-${module_name}__Content`);

  const heading = document.createElement('h2');
  heading.classList.add(`Module-${module_name}__Heading`);
  heading.innerHTML = extractHeading(settings.heading);

  const productsContainer = document.createElement('div');
  productsContainer.classList.add(`Module-${module_name}__Products`);
  productsContainer.setAttribute('data-cms-collection-slider', '');
  productsContainer.setAttribute('data-accent-color-container', '');
  productsContainer.innerHTML = products;

  headingContainer.appendChild(heading);
  headingContainer.appendChild(productsContainer);

  return headingContainer.outerHTML;
};
